export const orderStatusMap = {
  wait_pay: '待付款',
  wait_confirm: '待确认',
  preparing: '备货中',
  wait_delivery: '待发货',
  partial_delivery: '部分发货',
  wait_receive: '待收货',
  wait_comment: '待评价',
  wait_pickup: '待自提',
  complete: '已完成',
  cancel: '已取消'
}
